<template>
  <el-row class="welcome-container mobile-position-fixed">
    <el-row class="logo-row">
      <el-col class="grid-content">
        <div class="welcome-title">
          <img
            v-if="isMobile"
            class="logo1"
            src="../assets/Z1-W.svg"
          >
          <img
            v-else
            class="desktop-logo"
            src="../assets/Z1-R.svg"
          >
        </div>
        <div class="welcome-subtitle">
          {{ $t('welcome.title.text') }}
        </div>
      </el-col>
    </el-row>
    <el-row class="custom-flex flex-column-items-xs">
      <el-col class="grid-content flex-full-xs flex-column-items-xs">
        <welcome-box />
      </el-col>
    </el-row>
    <el-row
      v-if="!isMobile"
      type="flex"
      justify="center"
    >
      <p class="privacy">
        {{ $t('sign-up.terms-privacy') }}
        <router-link :to="{ name: 'Terms and Conditions' }">
          {{ $t('sign-up.terms') }}
        </router-link>
        {{ $t('sign-up.and') }}
        <router-link :to="{ name: 'Privacy policy' }">
          {{ $t('sign-up.privacy') }}
        </router-link>
      </p>
    </el-row>
  </el-row>
</template>

<script>

/* eslint-disable no-unused-vars */

import { mapState } from 'vuex';
import WelcomeBox from '../components/WelcomeBox';

export default {
  components: {
    WelcomeBox,
  },
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
    }),
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Welcome.vue